import React, { useState, useEffect } from 'react';
import {
  CurrencyDollarIcon,
  PlusIcon,
  MagnifyingGlassIcon,
  FunnelIcon,
  DocumentTextIcon,
  BanknotesIcon,
  ExclamationTriangleIcon,
  CheckCircleIcon,
  ClockIcon,
  PencilIcon,
  TrashIcon,
  TruckIcon,
  ArrowPathIcon,
  CalendarIcon
} from '@heroicons/react/24/outline';
import { api } from '../services/authService';

export default function ContasPagarPage() {
  const [contasPagar, setContasPagar] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [recorrencias, setRecorrencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalNova, setModalNova] = useState(false);
  const [modalRecorrente, setModalRecorrente] = useState(false);
  const [modalEdicao, setModalEdicao] = useState(false);
  const [contaEditando, setContaEditando] = useState(null);

  const [filtros, setFiltros] = useState({
    status: '',
    fornecedor: '',
    account_class: '',
    startDate: '',
    endDate: '',
    search: ''
  });

  const [novaConta, setNovaConta] = useState({
    supplier_id: '',
    vehicle_id: '',
    account_class: 'despesa_manutencao',
    cost_center: '',
    gross_amount: '',
    discount_amount: '0',
    issue_date: new Date().toISOString().split('T')[0],
    due_date: '',
    payment_method: '',
    bank_account: '',
    document_number: '',
    description: '',
    notes: ''
  });

  const [contaRecorrente, setContaRecorrente] = useState({
    name: '',
    frequency: 'mensal',
    start_date: new Date().toISOString().split('T')[0],
    end_date: '',
    installments: '12',
    supplier_id: '',
    vehicle_id: '',
    account_class: 'despesa_manutencao',
    cost_center: '',
    gross_amount: '',
    discount_amount: '0',
    description: '',
    notes: '',
    payment_method: '',
    business_day_rule: 'postpone'
  });

  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    overdue: 0,
    paid: 0,
    totalAmount: 0,
    pendingAmount: 0,
    overdueAmount: 0,
    paidAmount: 0
  });

  const accountClassOptions = [
    { value: 'despesa_manutencao', label: 'Manutenção de Veículos' },
    { value: 'despesa_combustivel', label: 'Combustível' },
    { value: 'despesa_seguro', label: 'Seguros' },
    { value: 'despesa_ipva', label: 'IPVA/Licenciamento' },
    { value: 'despesa_pessoal', label: 'Despesas com Pessoal' },
    { value: 'despesa_aluguel', label: 'Aluguel/Arrendamento' },
    { value: 'despesa_servico', label: 'Serviços de Terceiros' },
    { value: 'despesa_administrativa', label: 'Despesas Administrativas' },
    { value: 'despesa_financeira', label: 'Despesas Financeiras' },
    { value: 'outras_despesas', label: 'Outras Despesas' }
  ];

  const frequencyOptions = [
    { value: 'semanal', label: 'Semanal' },
    { value: 'quinzenal', label: 'Quinzenal' },
    { value: 'mensal', label: 'Mensal' },
    { value: 'bimestral', label: 'Bimestral' },
    { value: 'trimestral', label: 'Trimestral' },
    { value: 'semestral', label: 'Semestral' },
    { value: 'anual', label: 'Anual' }
  ];

  const paymentMethodOptions = [
    { value: 'dinheiro', label: 'Dinheiro' },
    { value: 'transferencia', label: 'Transferência Bancária' },
    { value: 'cheque', label: 'Cheque' },
    { value: 'boleto', label: 'Boleto' },
    { value: 'pix', label: 'PIX' },
    { value: 'cartao_credito', label: 'Cartão de Crédito' },
    { value: 'cartao_debito', label: 'Cartão de Débito' },
    { value: 'debito_automatico', label: 'Débito Automático' }
  ];

  const businessDayRuleOptions = [
    { value: 'postpone', label: 'Postergar para próximo dia útil' },
    { value: 'anticipate', label: 'Antecipar para dia útil anterior' },
    { value: 'none', label: 'Manter data original (não ajustar)' }
  ];

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    await Promise.all([
      carregarContasPagar(),
      carregarFornecedores(),
      carregarVeiculos(),
      carregarRecorrencias()
    ]);
  };

  const carregarContasPagar = async () => {
    setLoading(true);
    try {
      const response = await api.get('/api/payables');
      const data = response.data;
      const contas = data.data || [];
      setContasPagar(contas);
      calcularEstatisticas(contas);
    } catch (error) {
      console.error('Erro ao carregar contas a pagar:', error);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
    setLoading(false);
  };

  const carregarFornecedores = async () => {
    try {
      const response = await api.get('/api/clients');
      const data = response.data;
      setFornecedores(data.data || []);
    } catch (error) {
      console.error('Erro ao carregar fornecedores:', error);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
  };

  const carregarVeiculos = async () => {
    try {
      const response = await api.get('/api/vehicles');
      const data = response.data;
      setVeiculos(data.data || []);
    } catch (error) {
      console.error('Erro ao carregar veículos:', error);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
  };

  const carregarRecorrencias = async () => {
    try {
      const response = await api.get('/api/payables/recurrences/list');
      const data = response.data;
      setRecorrencias(data.data || []);
    } catch (error) {
      console.error('Erro ao carregar recorrências:', error);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
  };

  const calcularEstatisticas = (contas) => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    let totalAmount = 0;
    let pendingAmount = 0;
    let overdueAmount = 0;
    let paidAmount = 0;

    let total = contas.length;
    let pending = 0;
    let overdue = 0;
    let paid = 0;

    contas.forEach(conta => {
      const valor = parseFloat(conta.net_amount || 0);
      const vencimento = new Date(conta.due_date);
      vencimento.setHours(0, 0, 0, 0);

      totalAmount += valor;

      if (conta.status === 'paid') {
        paid++;
        paidAmount += valor;
      } else if (conta.status === 'pending') {
        if (vencimento < hoje) {
          overdue++;
          overdueAmount += valor;
        } else {
          pending++;
          pendingAmount += valor;
        }
      }
    });

    setStats({
      total,
      pending,
      overdue,
      paid,
      totalAmount,
      pendingAmount,
      overdueAmount,
      paidAmount
    });
  };

  const criarConta = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/payables', {
        ...novaConta,
        gross_amount: parseFloat(novaConta.gross_amount),
        discount_amount: parseFloat(novaConta.discount_amount || 0)
      });

      alert('Conta a pagar criada com sucesso!');
      setModalNova(false);
      resetarFormulario();
      carregarContasPagar();
    } catch (error) {
      console.error('Erro:', error);
      const message = error.response?.data?.error || 'Erro ao criar conta a pagar';
      alert(message);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
  };

  const criarContaRecorrente = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/payables/recurrence', {
        ...contaRecorrente,
        gross_amount: parseFloat(contaRecorrente.gross_amount),
        discount_amount: parseFloat(contaRecorrente.discount_amount || 0),
        installments: parseInt(contaRecorrente.installments)
      });

      const result = response.data;
      alert(`${result.data.payables.length} contas criadas com sucesso!`);
      setModalRecorrente(false);
      resetarFormularioRecorrente();
      carregarContasPagar();
      carregarRecorrencias();
    } catch (error) {
      console.error('Erro:', error);
      const message = error.response?.data?.error || 'Erro ao criar contas recorrentes';
      alert(message);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
  };

  const editarConta = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/api/payables/${contaEditando.id}`, {
        ...novaConta,
        gross_amount: parseFloat(novaConta.gross_amount),
        discount_amount: parseFloat(novaConta.discount_amount || 0)
      });

      alert('Conta a pagar atualizada com sucesso!');
      setModalEdicao(false);
      setContaEditando(null);
      resetarFormulario();
      carregarContasPagar();
    } catch (error) {
      console.error('Erro:', error);
      const message = error.response?.data?.error || 'Erro ao atualizar conta a pagar';
      alert(message);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
  };

  const marcarComoPaga = async (contaId) => {
    if (!confirm('Confirma o pagamento desta conta?')) return;

    try {
      await api.put(`/api/payables/${contaId}/status`, {
        status: 'paid',
        paid_date: new Date().toISOString()
      });

      alert('Pagamento confirmado!');
      carregarContasPagar();
    } catch (error) {
      console.error('Erro:', error);
      const message = error.response?.data?.error || 'Erro ao confirmar pagamento';
      alert(message);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
  };

  const excluirConta = async (contaId) => {
    if (!confirm('Confirma a exclusão desta conta a pagar?')) return;

    try {
      await api.delete(`/api/payables/${contaId}`);

      alert('Conta excluída com sucesso!');
      carregarContasPagar();
    } catch (error) {
      console.error('Erro:', error);
      const message = error.response?.data?.error || 'Erro ao excluir conta';
      alert(message);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
  };

  const cancelarRecorrencia = async (recorrenciaId) => {
    if (!confirm('Deseja cancelar esta recorrência? Todas as parcelas pendentes serão canceladas.')) return;

    try {
      await api.delete(`/api/payables/recurrences/${recorrenciaId}`);

      alert('Recorrência cancelada com sucesso!');
      carregarContasPagar();
      carregarRecorrencias();
    } catch (error) {
      console.error('Erro:', error);
      const message = error.response?.data?.error || 'Erro ao cancelar recorrência';
      alert(message);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    }
  };

  const abrirEdicao = (conta) => {
    setContaEditando(conta);
    setNovaConta({
      supplier_id: conta.supplier_id || '',
      vehicle_id: conta.vehicle_id || '',
      account_class: conta.account_class || 'despesa_manutencao',
      cost_center: conta.cost_center || '',
      gross_amount: conta.gross_amount || '',
      discount_amount: conta.discount_amount || '0',
      issue_date: conta.issue_date ? conta.issue_date.split('T')[0] : '',
      due_date: conta.due_date ? conta.due_date.split('T')[0] : '',
      payment_method: conta.payment_method || '',
      bank_account: conta.bank_account || '',
      document_number: conta.document_number || '',
      description: conta.description || '',
      notes: conta.notes || ''
    });
    setModalEdicao(true);
  };

  const resetarFormulario = () => {
    setNovaConta({
      supplier_id: '',
      vehicle_id: '',
      account_class: 'despesa_manutencao',
      cost_center: '',
      gross_amount: '',
      discount_amount: '0',
      issue_date: new Date().toISOString().split('T')[0],
      due_date: '',
      payment_method: '',
      bank_account: '',
      document_number: '',
      description: '',
      notes: ''
    });
  };

  const resetarFormularioRecorrente = () => {
    setContaRecorrente({
      name: '',
      frequency: 'mensal',
      start_date: new Date().toISOString().split('T')[0],
      end_date: '',
      installments: '12',
      supplier_id: '',
      vehicle_id: '',
      account_class: 'despesa_manutencao',
      cost_center: '',
      gross_amount: '',
      discount_amount: '0',
      description: '',
      notes: '',
      payment_method: '',
      business_day_rule: 'postpone'
    });
  };

  const getStatusInfo = (status, dueDate) => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const vencimento = new Date(dueDate);
    vencimento.setHours(0, 0, 0, 0);

    if (status === 'paid') {
      return { color: '#27ae60', icon: CheckCircleIcon, text: 'Paga' };
    } else if (status === 'pending' && vencimento < hoje) {
      return { color: '#e74c3c', icon: ExclamationTriangleIcon, text: 'Vencida' };
    } else if (status === 'pending') {
      return { color: '#f39c12', icon: ClockIcon, text: 'Pendente' };
    }
    return { color: '#95a5a6', icon: ClockIcon, text: 'Indefinido' };
  };

  const getAccountClassLabel = (value) => {
    const option = accountClassOptions.find(opt => opt.value === value);
    return option ? option.label : value;
  };

  const getFrequencyLabel = (value) => {
    const option = frequencyOptions.find(opt => opt.value === value);
    return option ? option.label : value;
  };

  const formatarData = (dateString) => {
    if (!dateString) return '';
    // Evita problema de timezone ao trabalhar apenas com a string da data
    const [year, month, day] = dateString.split('T')[0].split('-');
    return `${day}/${month}/${year}`;
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor || 0);
  };

  const calcularValorLiquido = (gross, discount) => {
    const bruto = parseFloat(gross) || 0;
    const desc = parseFloat(discount) || 0;
    return bruto - desc;
  };

  const contasFiltradas = contasPagar.filter(conta => {
    if (filtros.status && conta.status !== filtros.status) return false;
    if (filtros.fornecedor && conta.supplier_id !== parseInt(filtros.fornecedor)) return false;
    if (filtros.account_class && conta.account_class !== filtros.account_class) return false;
    if (filtros.startDate && new Date(conta.due_date) < new Date(filtros.startDate)) return false;
    if (filtros.endDate && new Date(conta.due_date) > new Date(filtros.endDate)) return false;
    if (filtros.search) {
      const searchLower = filtros.search.toLowerCase();
      const matchesDescription = conta.description?.toLowerCase().includes(searchLower);
      const matchesSupplier = conta.supplier_name?.toLowerCase().includes(searchLower);
      const matchesReference = conta.reference_code?.toLowerCase().includes(searchLower);
      if (!matchesDescription && !matchesSupplier && !matchesReference) return false;
    }
    return true;
  });

  const limparFiltros = () => {
    setFiltros({
      status: '',
      fornecedor: '',
      account_class: '',
      startDate: '',
      endDate: '',
      search: ''
    });
  };

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-6">
      {/* Header */}
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Contas a Pagar</h1>
            <p className="text-gray-600">Gestão completa de pagamentos e despesas</p>
          </div>
          <div className="flex items-center space-x-3">
            <BanknotesIcon className="w-8 h-8 text-red-600" />
            <button
              onClick={() => setModalRecorrente(true)}
              className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2"
            >
              <ArrowPathIcon className="w-5 h-5" />
              <span>Recorrente</span>
            </button>
            <button
              onClick={() => setModalNova(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2"
            >
              <PlusIcon className="w-5 h-5" />
              <span>Nova Conta</span>
            </button>
          </div>
        </div>
      </div>

      {/* Estatísticas */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center">
            <DocumentTextIcon className="w-8 h-8 text-blue-600" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Total</p>
              <p className="text-2xl font-bold text-gray-900">{stats.total}</p>
              <p className="text-sm text-gray-500">{formatarMoeda(stats.totalAmount)}</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center">
            <ClockIcon className="w-8 h-8 text-yellow-600" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Pendentes</p>
              <p className="text-2xl font-bold text-yellow-600">{stats.pending}</p>
              <p className="text-sm text-gray-500">{formatarMoeda(stats.pendingAmount)}</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center">
            <ExclamationTriangleIcon className="w-8 h-8 text-red-600" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Vencidas</p>
              <p className="text-2xl font-bold text-red-600">{stats.overdue}</p>
              <p className="text-sm text-gray-500">{formatarMoeda(stats.overdueAmount)}</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center">
            <CheckCircleIcon className="w-8 h-8 text-green-600" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Pagas</p>
              <p className="text-2xl font-bold text-green-600">{stats.paid}</p>
              <p className="text-sm text-gray-500">{formatarMoeda(stats.paidAmount)}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Recorrências Ativas */}
      {recorrencias.length > 0 && (
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
            <ArrowPathIcon className="w-5 h-5 mr-2 text-purple-600" />
            Recorrências Ativas ({recorrencias.length})
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {recorrencias.map((rec) => (
              <div key={rec.id} className="border border-gray-200 rounded-lg p-4">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-gray-900">{rec.name}</h4>
                  <button
                    onClick={() => cancelarRecorrencia(rec.id)}
                    className="text-red-600 hover:text-red-800 text-sm"
                  >
                    Cancelar
                  </button>
                </div>
                <p className="text-sm text-gray-600">{rec.supplier_name}</p>
                <p className="text-sm text-gray-600">{getFrequencyLabel(rec.frequency)}</p>
                <p className="text-sm font-bold text-gray-900 mt-2">
                  {formatarMoeda(rec.gross_amount)}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  {rec.paid_installments || 0}/{rec.total_installments || 0} parcelas pagas
                </p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Filtros */}
      <div className="bg-white p-6 rounded-lg shadow">
        <div className="grid grid-cols-1 md:grid-cols-7 gap-4">
          <div className="md:col-span-2">
            <div className="relative">
              <MagnifyingGlassIcon className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
              <input
                type="text"
                placeholder="Buscar..."
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                value={filtros.search}
                onChange={(e) => setFiltros({...filtros, search: e.target.value})}
              />
            </div>
          </div>

          <select
            className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            value={filtros.status}
            onChange={(e) => setFiltros({...filtros, status: e.target.value})}
          >
            <option value="">Todos os Status</option>
            <option value="pending">Pendente</option>
            <option value="paid">Paga</option>
          </select>

          <select
            className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            value={filtros.account_class}
            onChange={(e) => setFiltros({...filtros, account_class: e.target.value})}
          >
            <option value="">Todas as Classes</option>
            {accountClassOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>

          <select
            className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            value={filtros.fornecedor}
            onChange={(e) => setFiltros({...filtros, fornecedor: e.target.value})}
          >
            <option value="">Todos Fornecedores</option>
            {fornecedores.map(fornecedor => (
              <option key={fornecedor.id} value={fornecedor.id}>
                {fornecedor.name}
              </option>
            ))}
          </select>

          <input
            type="date"
            className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            value={filtros.startDate}
            onChange={(e) => setFiltros({...filtros, startDate: e.target.value})}
          />

          <input
            type="date"
            className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            value={filtros.endDate}
            onChange={(e) => setFiltros({...filtros, endDate: e.target.value})}
          />

          <button
            onClick={limparFiltros}
            className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg flex items-center justify-center"
          >
            <FunnelIcon className="w-4 h-4 mr-2" />
            Limpar
          </button>
        </div>
      </div>

      {/* Tabela */}
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">
            Contas a Pagar ({contasFiltradas.length})
          </h3>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          </div>
        ) : contasFiltradas.length === 0 ? (
          <div className="text-center py-12">
            <BanknotesIcon className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">Nenhuma conta encontrada</h3>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Referência / Fornecedor
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Classe Financeira
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Veículo
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Valor Líquido
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Vencimento
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {contasFiltradas.map((conta) => {
                  const statusInfo = getStatusInfo(conta.status, conta.due_date);
                  const StatusIcon = statusInfo.icon;

                  return (
                    <tr key={conta.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4">
                        <div>
                          <div className="text-sm font-medium text-gray-900">
                            {conta.reference_code}
                          </div>
                          <div className="text-sm text-gray-500">
                            {conta.supplier_name}
                          </div>
                          <div className="text-xs text-gray-400">
                            {conta.description}
                          </div>
                          {conta.recurrence_name && (
                            <div className="flex items-center text-xs text-purple-600 mt-1">
                              <ArrowPathIcon className="w-3 h-3 mr-1" />
                              {conta.recurrence_name}
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm text-gray-900">
                          {getAccountClassLabel(conta.account_class)}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        {conta.vehicle_model ? (
                          <div className="flex items-center">
                            <TruckIcon className="w-4 h-4 text-gray-400 mr-2" />
                            <div>
                              <div className="text-sm text-gray-900">{conta.vehicle_model}</div>
                              <div className="text-xs text-gray-500">{conta.vehicle_plate}</div>
                            </div>
                          </div>
                        ) : (
                          <span className="text-sm text-gray-400">-</span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm font-bold text-red-600">
                          {formatarMoeda(conta.net_amount)}
                        </div>
                        {conta.discount_amount > 0 && (
                          <div className="text-xs text-gray-500">
                            Bruto: {formatarMoeda(conta.gross_amount)}
                          </div>
                        )}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-900">
                        {formatarData(conta.due_date)}
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium" style={{
                          backgroundColor: `${statusInfo.color}20`,
                          color: statusInfo.color
                        }}>
                          <StatusIcon className="w-3 h-3 mr-1" />
                          {statusInfo.text}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          {conta.status === 'pending' && (
                            <button
                              onClick={() => marcarComoPaga(conta.id)}
                              className="text-green-600 hover:text-green-900"
                              title="Marcar como Paga"
                            >
                              <CheckCircleIcon className="w-5 h-5" />
                            </button>
                          )}
                          
                          <button
                            onClick={() => abrirEdicao(conta)}
                            className="text-blue-600 hover:text-blue-900"
                            title="Editar"
                          >
                            <PencilIcon className="w-5 h-5" />
                          </button>
                          
                          <button
                            onClick={() => excluirConta(conta.id)}
                            className="text-red-600 hover:text-red-900"
                            title="Excluir"
                          >
                            <TrashIcon className="w-5 h-5" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal Nova Conta */}
      {modalNova && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-10 mx-auto p-5 border w-full max-w-3xl shadow-lg rounded-md bg-white">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium text-gray-900">Nova Conta a Pagar</h3>
              <button onClick={() => { setModalNova(false); resetarFormulario(); }} className="text-gray-400 hover:text-gray-600">×</button>
            </div>
            
            <form onSubmit={criarConta} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fornecedor *</label>
                  <select value={novaConta.supplier_id} onChange={(e) => setNovaConta({...novaConta, supplier_id: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    <option value="">Selecione</option>
                    {fornecedores.map(fornecedor => (
                      <option key={fornecedor.id} value={fornecedor.id}>{fornecedor.name}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Classe Financeira *</label>
                  <select value={novaConta.account_class} onChange={(e) => setNovaConta({...novaConta, account_class: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    {accountClassOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Veículo</label>
                  <select value={novaConta.vehicle_id} onChange={(e) => setNovaConta({...novaConta, vehicle_id: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    <option value="">Nenhum</option>
                    {veiculos.map(veiculo => (
                      <option key={veiculo.id} value={veiculo.id}>{veiculo.model} - {veiculo.license_plate}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Centro de Custo</label>
                  <input type="text" value={novaConta.cost_center} onChange={(e) => setNovaConta({...novaConta, cost_center: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Valor Bruto *</label>
                  <input type="number" step="0.01" value={novaConta.gross_amount} onChange={(e) => setNovaConta({...novaConta, gross_amount: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Desconto</label>
                  <input type="number" step="0.01" value={novaConta.discount_amount} onChange={(e) => setNovaConta({...novaConta, discount_amount: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                  <p className="text-xs text-gray-500 mt-1">Líquido: {formatarMoeda(calcularValorLiquido(novaConta.gross_amount, novaConta.discount_amount))}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data Emissão *</label>
                  <input type="date" value={novaConta.issue_date} onChange={(e) => setNovaConta({...novaConta, issue_date: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data Vencimento *</label>
                  <input type="date" value={novaConta.due_date} onChange={(e) => setNovaConta({...novaConta, due_date: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Forma de Pagamento</label>
                  <select value={novaConta.payment_method} onChange={(e) => setNovaConta({...novaConta, payment_method: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    <option value="">Selecione</option>
                    {paymentMethodOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Conta Bancária</label>
                  <input type="text" value={novaConta.bank_account} onChange={(e) => setNovaConta({...novaConta, bank_account: e.target.value})} placeholder="Ex: Banco 001 - Ag 1234" className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descrição *</label>
                <input type="text" value={novaConta.description} onChange={(e) => setNovaConta({...novaConta, description: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Observações</label>
                <textarea value={novaConta.notes} onChange={(e) => setNovaConta({...novaConta, notes: e.target.value})} rows={2} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
              </div>

              <div className="flex space-x-3">
                <button type="button" onClick={() => { setModalNova(false); resetarFormulario(); }} className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-lg">Cancelar</button>
                <button type="submit" className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg">Criar Conta</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Conta Recorrente - Continua no próximo artefato devido ao limite de tamanho */}
      {modalRecorrente && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-10 mx-auto p-5 border w-full max-w-3xl shadow-lg rounded-md bg-white">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium text-gray-900 flex items-center">
                <ArrowPathIcon className="w-5 h-5 mr-2 text-purple-600" />
                Criar Contas Recorrentes
              </h3>
              <button onClick={() => { setModalRecorrente(false); resetarFormularioRecorrente(); }} className="text-gray-400 hover:text-gray-600">×</button>
            </div>
            
            <form onSubmit={criarContaRecorrente} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nome da Recorrência *</label>
                  <input type="text" value={contaRecorrente.name} onChange={(e) => setContaRecorrente({...contaRecorrente, name: e.target.value})} required placeholder="Ex: Aluguel Mensal, Seguro Anual" className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Frequência *</label>
                  <select value={contaRecorrente.frequency} onChange={(e) => setContaRecorrente({...contaRecorrente, frequency: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    {frequencyOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Número de Parcelas *</label>
                  <input type="number" min="1" max="120" value={contaRecorrente.installments} onChange={(e) => setContaRecorrente({...contaRecorrente, installments: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data Início *</label>
                  <input type="date" value={contaRecorrente.start_date} onChange={(e) => setContaRecorrente({...contaRecorrente, start_date: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fornecedor *</label>
                  <select value={contaRecorrente.supplier_id} onChange={(e) => setContaRecorrente({...contaRecorrente, supplier_id: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    <option value="">Selecione</option>
                    {fornecedores.map(fornecedor => (
                      <option key={fornecedor.id} value={fornecedor.id}>{fornecedor.name}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Classe Financeira *</label>
                  <select value={contaRecorrente.account_class} onChange={(e) => setContaRecorrente({...contaRecorrente, account_class: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    {accountClassOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Veículo</label>
                  <select value={contaRecorrente.vehicle_id} onChange={(e) => setContaRecorrente({...contaRecorrente, vehicle_id: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    <option value="">Nenhum</option>
                    {veiculos.map(veiculo => (
                      <option key={veiculo.id} value={veiculo.id}>{veiculo.model} - {veiculo.license_plate}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Valor Bruto *</label>
                  <input type="number" step="0.01" value={contaRecorrente.gross_amount} onChange={(e) => setContaRecorrente({...contaRecorrente, gross_amount: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Desconto</label>
                  <input type="number" step="0.01" value={contaRecorrente.discount_amount} onChange={(e) => setContaRecorrente({...contaRecorrente, discount_amount: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                  <p className="text-xs text-gray-500 mt-1">Líquido por parcela: {formatarMoeda(calcularValorLiquido(contaRecorrente.gross_amount, contaRecorrente.discount_amount))}</p>
                </div>
              </div>

              <div className="col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Ajuste para Dias Úteis</label>
                <select
                  value={contaRecorrente.business_day_rule}
                  onChange={(e) => setContaRecorrente({...contaRecorrente, business_day_rule: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                >
                  {businessDayRuleOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-1">
                  Como tratar vencimentos que caem em fins de semana
                </p>
              </div>

              <div className="col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Descrição *</label>
                <input type="text" value={contaRecorrente.description} onChange={(e) => setContaRecorrente({...contaRecorrente, description: e.target.value})} required placeholder="Será acrescentado número da parcela" className="w-full border border-gray-300 rounded-lg px-3 py-2" />
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-blue-900">
                  <strong>Resumo:</strong> Serão criadas {contaRecorrente.installments} parcelas de {formatarMoeda(calcularValorLiquido(contaRecorrente.gross_amount, contaRecorrente.discount_amount))} cada, com frequência {getFrequencyLabel(contaRecorrente.frequency).toLowerCase()}.
                </p>
                <p className="text-sm text-blue-900 mt-1">
                  <strong>Total:</strong> {formatarMoeda(calcularValorLiquido(contaRecorrente.gross_amount, contaRecorrente.discount_amount) * parseInt(contaRecorrente.installments || 0))}
                </p>
              </div>

              <div className="flex space-x-3">
                <button type="button" onClick={() => { setModalRecorrente(false); resetarFormularioRecorrente(); }} className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-lg">Cancelar</button>
                <button type="submit" className="flex-1 bg-purple-600 hover:bg-purple-700 text-white py-2 px-4 rounded-lg">Criar Recorrência</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Edição */}
      {modalEdicao && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-10 mx-auto p-5 border w-full max-w-3xl shadow-lg rounded-md bg-white">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium text-gray-900">Editar Conta a Pagar</h3>
              <button onClick={() => { setModalEdicao(false); setContaEditando(null); resetarFormulario(); }} className="text-gray-400 hover:text-gray-600">×</button>
            </div>

            <form onSubmit={editarConta} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fornecedor *</label>
                  <select value={novaConta.supplier_id} onChange={(e) => setNovaConta({...novaConta, supplier_id: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    <option value="">Selecione</option>
                    {fornecedores.map(fornecedor => (
                      <option key={fornecedor.id} value={fornecedor.id}>{fornecedor.name}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Classe Financeira *</label>
                  <select value={novaConta.account_class} onChange={(e) => setNovaConta({...novaConta, account_class: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    {accountClassOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Veículo</label>
                  <select value={novaConta.vehicle_id} onChange={(e) => setNovaConta({...novaConta, vehicle_id: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    <option value="">Nenhum</option>
                    {veiculos.map(veiculo => (
                      <option key={veiculo.id} value={veiculo.id}>{veiculo.model} - {veiculo.license_plate}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Centro de Custo</label>
                  <input type="text" value={novaConta.cost_center} onChange={(e) => setNovaConta({...novaConta, cost_center: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Valor Bruto *</label>
                  <input type="number" step="0.01" value={novaConta.gross_amount} onChange={(e) => setNovaConta({...novaConta, gross_amount: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Desconto</label>
                  <input type="number" step="0.01" value={novaConta.discount_amount} onChange={(e) => setNovaConta({...novaConta, discount_amount: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                  <p className="text-xs text-gray-500 mt-1">Líquido: {formatarMoeda(calcularValorLiquido(novaConta.gross_amount, novaConta.discount_amount))}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data Emissão *</label>
                  <input type="date" value={novaConta.issue_date} onChange={(e) => setNovaConta({...novaConta, issue_date: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data Vencimento *</label>
                  <input type="date" value={novaConta.due_date} onChange={(e) => setNovaConta({...novaConta, due_date: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Forma de Pagamento</label>
                  <select value={novaConta.payment_method} onChange={(e) => setNovaConta({...novaConta, payment_method: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2">
                    <option value="">Selecione</option>
                    {paymentMethodOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Conta Bancária</label>
                  <input type="text" value={novaConta.bank_account} onChange={(e) => setNovaConta({...novaConta, bank_account: e.target.value})} placeholder="Ex: Banco 001 - Ag 1234" className="w-full border border-gray-300 rounded-lg px-3 py-2" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descrição *</label>
                <input type="text" value={novaConta.description} onChange={(e) => setNovaConta({...novaConta, description: e.target.value})} required className="w-full border border-gray-300 rounded-lg px-3 py-2" />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Observações</label>
                <textarea value={novaConta.notes} onChange={(e) => setNovaConta({...novaConta, notes: e.target.value})} rows={2} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
              </div>

              <div className="flex space-x-3">
                <button type="button" onClick={() => { setModalEdicao(false); setContaEditando(null); resetarFormulario(); }} className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-lg">Cancelar</button>
                <button type="submit" className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg">Atualizar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}